export default __webpack_public_path__ + "static/media/header.b188bba8.less";